import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

type PricingPlan = {
  readonly name: string;
  readonly price: number;
  readonly highlight: boolean;
  readonly features: string[];
  readonly smsLimit: string;
};

@Component({
  selector: 'app-pricing',

  templateUrl: './pricing.html',
  imports: [ButtonModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingComponent {
  readonly plans: PricingPlan[] = [
    {
      name: 'Basic',
      price: 60,
      highlight: false,
      smsLimit: '100 SMS per month',
      features: ['Manage dial to open users (direct)', 'Manage intercom users (direct)', 'Set keypad codes'],
    },
    {
      name: 'Standard',
      price: 120,
      highlight: true,
      smsLimit: 'Unlimited SMS',
      features: [
        'Manage dial to open users (server)',
        'Manage intercom users (server)',
        'Set keypad codes',
        'Delegate access to other users in organisation',
        'Import contacts',
      ],
    },
    {
      name: 'Pro',
      price: 240,
      highlight: false,
      smsLimit: 'Unlimited SMS',
      features: [
        'Manage dial to open users (server)',
        'Manage intercom users (server)',
        'Set keypad codes',
        'Delegate access to other users in organisation',
        'Import contacts',
      ],
    },
  ];
}
